export const urlConfig = {
  authBaseUrl: import.meta.env.VITE_AUTH_BASE_URL || "",
  ordersBaseUrl: import.meta.env.VITE_ORDERS_BASE_URL || "",
  productsBaseUrl: import.meta.env.VITE_PRODUCTS_BASE_URL || "",
  tradesBaseUrl: import.meta.env.VITE_TRADES_BASE_URL || "",
  walletsBaseUrl: import.meta.env.VITE_WALLETS_BASE_URL || "",
  chatsBaseUrl: import.meta.env.VITE_CHATS_BASE_URL || "",
  baseUrl: import.meta.env.VITE_API_BASE_URL || "",
  kycUrl: import.meta.env.VITE_KYC_URL || "",
  depositUrl: import.meta.env.VITE_DEPOSIT_URL || "",
  leaderboardsUrl: import.meta.env.VITE_LEADERBOARDS_BASE_URL || "",
  rateAlertUrl: import.meta.env.VITE_RATE_ALERT_BASE_URL || "",
  referralsUrl: import.meta.env.VITE_REFERRALS_BASE_URL || "",
  transactionHistoryUrl: import.meta.env.VITE_TRANSACTION_HISTORY_BASE_URL || "https://api.gcbuying.com",
  bankDepositUrl: import.meta.env.VITE_BANK_DEPOSITS_BASE_URL || "https://api.gcbuying.com",
  ebillsUrl: import.meta.env.VITE_EBILLS_BASE_URL || "https://api.gcbuying.com",
  transactionsBaseUrl: import.meta.env.VITE_TRANSACTIONS_BASE_URL || "https://api.gcbuying.com",
  reloadlyUrl: import.meta.env.VITE_RELOADLY_BASE_URL || "https://api.gcbuying.com",
  vipTradingUrl: import.meta.env.VITE_VIP_TRADING_URL || "https://api.gcbuying.com",
};
